"use client";

import { c as _c } from "react/compiler-runtime";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DetailRow from "./DetailRow";
import { getSurveyQuestionFlow } from "@/components/survey/_constants/surveyQuestions";
import { useEnquiryFlowStore } from "@/store/enquiryFlowStore";
import { useSurveySheetStore } from "@/store/surveySheetStore";
import { inhomzEvents } from "@/app/(fevicol-inhomz)/_lib/events";
import { profileEventProps } from "@/app/(fevicol-inhomz)/_lib/profileEventProps";
import { useInhomzTrack } from "@/app/(fevicol-inhomz)/_hooks/useInhomzTrack";

// Shows whatever was picked on the survey step. Per the PRD, this whole
// section is only shown if the survey was actually filled in — if it was
// skipped, `answers` is empty and the section doesn't render at all.
export default function ProjectDetailsCard(t0) {
  const $ = _c(9);
  const {
    answers: t1
  } = t0;
  const answers = t1 === undefined ? {} : t1;
  const goToReview = useEnquiryFlowStore(_temp);
  const openSurvey = useSurveySheetStore(_temp2);
  const digitalProfile = useEnquiryFlowStore(_temp3);
  const track = useInhomzTrack();
  if (!answers.propertyType) {
    return null;
  }
  const handleEdit = () => {
    track(inhomzEvents.reviewForm.PROJECT_DETAILS_EDIT_CLICKED, profileEventProps(digitalProfile));
    openSurvey({
      initialAnswers: answers,
      onComplete: updatedAnswers => goToReview({
        surveyAnswers: updatedAnswers
      }),
      onSkip: skippedAnswers => goToReview({
        surveyAnswers: skippedAnswers
      }),
      context: "enquiryFlow"
    });
  };
  const t2 = "flex flex-col gap-3";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2 className="m3-title-medium text-[--textPrimaryPrimary]">Project details</h2>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <EditOutlinedIcon sx={{
      fontSize: "20px"
    }} className="text-[--colorPrimaryPrimary]" />;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== handleEdit) {
    t5 = <div className="flex items-center justify-between">{t3}<button type="button" onClick={handleEdit} aria-label="Edit project details">{t4}</button></div>;
    $[2] = handleEdit;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = "flex flex-col divide-y divide-[--colorSecondarySecondaryContainer] rounded-[--radius28] bg-[--colorSurfaceSurface]";
  const t7 = getSurveyQuestionFlow(answers).map(q => {
    const Icon = q.icon;
    return <DetailRow key={q.id} icon={<Icon sx={{
      fontSize: "22px"
    }} />} label={q.reviewLabel} value={answers[q.id]} />;
  });
  let t8;
  if ($[4] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[4] = t7;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== t5 || $[7] !== t8) {
    t9 = <section className={t2}>{t5}{t8}</section>;
    $[6] = t5;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  return t9;
}
function _temp3(state_1) {
  return state_1.digitalProfile;
}
function _temp2(state_0) {
  return state_0.open;
}
function _temp(state) {
  return state.goToReview;
}